import React from "react";
import { Helmet } from "react-helmet-async";

const faqs = [
  {
    question: "Quanto tempo leva para instalar um sistema de energia solar?",
    answer: "A maioria das residências é instalada em 1 a 3 dias após aprovação do projeto e liberação da concessionária."
  },
  {
    question: "Qual a economia média que posso atingir em Araçatuba?",
    answer: "Clientes residenciais frequentemente reduzem entre 70% e 95% da fatura, dependendo do perfil de consumo e dimensionamento."
  },
  {
    question: "Em quanto tempo ocorre o payback do investimento?",
    answer: "Normalmente entre 3 e 6 anos na região, variando conforme consumo, tarifa e incentivos regulatórios."
  }
];

const FAQSchema = () => {
  const data = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(f => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.answer
      }
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default FAQSchema;
export { faqs };
